/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/components/Navbars/AdminNavbar.js

import {
  Flex,
  useColorModeValue,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);

  // Scroll durumuna göre state güncelleyen fonksiyon
  const changeNavbar = () => {
    if (window.scrollY > 1) setScrolled(true);
    else setScrolled(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);
    return () => window.removeEventListener("scroll", changeNavbar);
  }, []);

  // Props - Filter out non-DOM props to avoid React warnings
  const { fixed, secondary, onOpen, brandText, staticContext, sidebarOpen = true, onSidebarToggle, ...rest } = props;

  // Renk ve stil hesaplamaları (hook'lar üst seviyede)
  const navbarBgScrolled = useColorModeValue("white", "navy.800");
  const navbarBorderScrolled = useColorModeValue("transparent", "transparent");
  const navbarShadowValue = useColorModeValue(
    "0px 7px 23px rgba(0, 0, 0, 0.05)",
    "0px 7px 23px rgba(0, 0, 0, 0.05)"
  );
  const navbarFilter = useColorModeValue("none", "none");
  const navbarBackdrop = useColorModeValue("none", "none");
  const paddingX = useBreakpointValue({ base: "15px", md: "30px" });
  const navbarBg = fixed && scrolled ? navbarBgScrolled : "transparent";
  const navbarBorder = fixed && scrolled ? navbarBorderScrolled : "transparent";
  const navbarShadow = fixed && scrolled ? navbarShadowValue : "none";

  return (
    <Flex
      position={fixed ? "fixed" : "absolute"}
      top="8px"
      right="0"                         // ✅ sağa sabitledik
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transition="box-shadow 0.25s linear, background-color 0.25s linear"
      alignItems="center"
      borderRadius="16px"
      display="flex"
      minH="60px"
      px={{ sm: paddingX, md: "30px" }}
      pt="6px"
      pb="6px"
      w={sidebarOpen ? "calc(100% - 275px)" : "calc(100% - 30px)"}  // ✅ sidebar açık/kapalı durumuna göre genişlik
      zIndex="1000"
      pointerEvents="none"              // ✅ Navbar'ın kendisi tıklamaları engellemez
      {...rest}
    >
      <Flex
        w="100%"
        direction="row"
        align="center"
        justify="flex-end"              // ✅ içindekiler de sağa yaslı
        pointerEvents="auto"            // ✅ İçindeki elementler tıklanabilir
      >
          <AdminNavbarLinks
            onOpen={onOpen}
            secondary={secondary}
            fixed={fixed}
            scrolled={scrolled}
            sidebarOpen={sidebarOpen}
            onSidebarToggle={onSidebarToggle}
            {...rest}
          />
      </Flex>
    </Flex>
  );
}
